export const getUltimoPesaje = (pesajes) => {
    if (!pesajes || pesajes.length === 0) return {};
    return pesajes[pesajes.length - 1];
}